import React from 'react';
import { Typewriter } from 'react-simple-typewriter'
import './About.css'

const About = () => {
    return (
        <div className='mx-10 my-10' id='about'>
            <div>
                <span className='title '>BIOGRAPHY</span>
                <h3 className='subtitle'>About Me</h3>
            </div>

            <div className='flex flex-col lg:flex-row lg:items-center justify-between'>
                <div className='basis-1/2'>
                    <h3 className='my-5 about-title'>I'm Abdur Rahman Apu and
                        <span style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}>
                            <Typewriter
                                words={[' Front-end Developer', ' JavaScript Developer', ' React Developer', ' Web developer']}
                                loop={1 / 0}
                                cursor
                                cursorStyle='|'
                                typeSpeed={170}
                                deleteSpeed={170}
                                delaySpeed={1000}

                            />
                        </span>
                    </h3>

                    <p className='mt-10 text-justify about-info text-gray-500'>
                        Hi! My name is <i style={{ color: 'var(--primary-color' }}>Abdur Rahman</i>. I am a Web Developer, and I'm very passionate and dedicated to my work. With 1.5 years experience as a Web developer, I have acquired the skills and knowledge necessary to make your project a success.
                    </p>
                </div>
                <div className='ml-10 mt-10 lg:mt-0 basis-1/2 personal-info'>
                    <h3 className='title'>Personal information</h3>
                    <ul className='lg:flex gap-8'>
                        <div className='basis-1/2'>
                            <li> <i class="fa fa-gift" aria-hidden="true"></i> <span className='font-bold'>BirthDay: </span> 25-03-1999</li>
                            <li> <i class="fa-solid fa-calendar-days"></i> <span className="font-bold">Age:</span> 23 years</li>
                            <li><i class="fa-solid fa-graduation-cap"></i> <span className="font-bold">Degree: </span> Bachelor</li>
                            <li> <i class="fa fa-phone" aria-hidden="true"></i> <span className="font-bold">Cell:</span> 01981504997</li>
                        </div>
                        <div className='basis-1/2'>
                            <li><i class="fa-solid fa-earth-americas"></i> <span className="font-bold">Nationality: </span> Bangladeshi </li>
                            <li> <i class="fa-solid fa-language"></i> <span className="font-bold">Language:</span> English, Bengali</li>
                            <li> <i class="fa-solid fa-location-dot"></i> <span className="font-bold">Country:</span> Bangladesh</li>
                            <li><i class="fa-solid fa-briefcase"></i> <span className="font-bold"> Work:</span> Available</li>
                        </div>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default About;